import { useChainDeprecationPrompt } from './useChainDeprecationPrompt';

export const ChainDeprecationPrompt = () => {
  useChainDeprecationPrompt();
  return null;
};
